module.exports = __webpack_public_path__ + "img/voice_1.f52f14bb.png";